import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Glyphicon } from 'react-bootstrap';
import 'containers/request/Initial/Agreements/style.css';

const AgreementsModal = ({
  show,
  title,
  modalHandler,
  downloadHandler,
  content,
  actionIcon,
  actionTitle
}) => {
  const ContentBody = content;
  return (
    <Modal show={show} onHide={modalHandler} bsSize="large">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ContentBody />
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="warning" onClick={downloadHandler}>
          <Glyphicon glyph={actionIcon} /> {actionTitle}
        </Button>
        <Button onClick={modalHandler} className="agr-close-btn">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AgreementsModal.propTypes = {
  show: PropTypes.bool,
  modalHandler: PropTypes.func
};

AgreementsModal.defaultProps = {
  title: 'License Agreement',
  actionIcon: 'print',
  actionTitle: 'Print'
};

export default AgreementsModal;



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Agreements/AgreementsModal.js